module.exports = __webpack_public_path__ + "img/rapido.0faff826.jpg";